import { letterService } from "../_services"

export default {
  namespaced: true,

  state: {
    filterIndex: 0,
    sorterIndex: 0,
    letters: null,
    envelopeFormats: null,
    mailTypes: null
  },


  getters: {
    letters ({ letters }) {
      // return letters ? letters.filter(l => l.sessionDocs.length).sort((a, b) => b.id - a.id) : []
      return letters ? letters.sort((a, b) => !b.createDate || b.createDate.localeCompare(a.createDate) || b.id - a.id) : []

    },

    envelopeFormats ({ envelopeFormats }) {
      return envelopeFormats.filter(item => ["C4", "C5", "C6"].includes(item.name)) || []
    },

    mailTypes ({ mailTypes }) {
      return mailTypes || []
    }

  },


  mutations: {
    setFilterIndex: (state, payload) => {
      state.filterIndex = payload
    },

    setSorterIndex: (state, payload) => {
      state.sorterIndex = payload
    },

    setLetters: (state, payload) => {
      state.letters = payload
    },

    setEnvelopeFormats: (state, payload) => {
      state.envelopeFormats = payload
    },

    setMailTypes: (state, payload) => {
      state.mailTypes = payload
    },

    replaceLetter: (state, letter) => {
      state.letters = state.letters ? state.letters.map(obj => obj.id === letter.id ? letter : obj) : []
    },

    moveLetter: (state, letter) => {
      state.letters = state.letters.filter(obj => obj.id !== letter.id )
      state.letters.push(letter)
    }
  },


  actions: {
    init: ({ dispatch }) => {
      dispatch('loadEnvelopeFormats')
      dispatch('loadMailTypes')
      dispatch('loadLetters')
    },

    refresh: ({ dispatch }) => {
      dispatch('loadLetters')
    },

    loadMailTypes: ({ commit }) => {
      letterService.getMailType()
      .then(data => {
        commit('setMailTypes', data)
      })
    },

    loadEnvelopeFormats: ({ commit }) => {
      letterService.getEnvelopeFormats()
      .then(data => {
        commit('setEnvelopeFormats', data)
      })
    },
    
    loadLetters: ({ commit }) => {
      letterService.list()
      .then(data => {
        commit('setLetters', data)
      })
    },

    updateLetter: ({ commit, dispatch }, letter) => {
      letterService.update(letter)
      .then(data => {
        if (letter.status.name.indexOf("RESPONSE") != -1) dispatch('requestEnvelope', letter)
        commit('replaceLetter', data)
      })
    },

    requestEnvelope: ({ commit }, letter) => {
      letterService.requestBarCode(letter.id)
      .then(data => {
        commit('replaceLetter', data)
      })
    },
    
    remove: ({ dispatch }, letter) => {
      letterService.remove(letter.id)
      .then(() => {
        dispatch('refresh')
      })
    },

    prepareToRegistry: ({ dispatch }, letter) => {
      letterService.setToRegistry(letter.id)
      .then(() => dispatch('refresh'))
    }
  }
}